import React from 'react';
import { Tabs, Tab, Paper, Typography, Box, makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import ParticipantService from '../ParticipantService';
import AuthenticationGrid from '../AuthenticateParticipant';
import NotificationGrid from '../Notification/index';
import { useParams } from 'react-router-dom';
import TenantUsers from '../TenantUsers';
import ErrorDiagnosiss from '../ED';

const useStyles = makeStyles(theme => ({
  tab: {
    borderBottomStyle: 'none !important' as 'none'
  }
}));

interface TabPanelProps {
  children: React.ReactNode;
  value: string;
  index: string;
}
function TabPanel(props: TabPanelProps) {
  const { children, value, index } = props;

  return (
    <Typography component="div" role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`}>
      {value === index && <Box>{children}</Box>}
    </Typography>
  );
}

interface CustomerTabsProps {
  data: participant;
  enableDetail: any;
  workflowCode?: any;
  participantCode: any;
}

type participant = {
  [key: string]: any;
};

const CustomerTabs = (props: CustomerTabsProps) => {
  const classes = useStyles();
  let { detailTab } = useParams();
  let tab = 'service';
  if (detailTab) {
    tab = detailTab;
  }
  const [value, setValue] = React.useState(tab);
  const handleChange = (_event: React.ChangeEvent<{}>, newValue: string) => {
    window.history.pushState('', '', '/participant/' + props.participantCode + '/' + newValue);
    props.enableDetail(false);
    setValue(newValue);
  };

  const history = useHistory();

  return (
    <Paper variant="outlined">
      <Tabs data-id="tabs" value={value} onChange={handleChange}>
        <Tab label="Services" className={classes.tab} value="service" />
        <Tab label="Authenticate" className={classes.tab} value="authenticate" />
        <Tab label="Error Diagnosis" className={classes.tab} value="errorDiagnosis" />
        <Tab label="Notifications" className={classes.tab} value="notification" />
        <Tab label="Users" className={classes.tab} value="user" />
      </Tabs>
      <TabPanel value={value} index="service">
        <ParticipantService participant={props.data} participantCode={props.participantCode} />
      </TabPanel>
      <TabPanel value={value} index="authenticate">
        <AuthenticationGrid participant={props.data} />
      </TabPanel>
      <TabPanel value={value} index="errorDiagnosis">
        <ErrorDiagnosiss
          id="ErrorDiagnosis"
          {...props}
          history={history}
          participant={props.data}
          workflowCode={undefined}
          search={history?.location?.search}
          isParticipantLevel
        />
      </TabPanel>
      <TabPanel value={value} index="notification">
        <NotificationGrid />
      </TabPanel>
      <TabPanel value={value} index="user">
        <TenantUsers participant={props.data} />
      </TabPanel>
    </Paper>
  );
};

export default CustomerTabs;
